import React from 'react';
import {
  initialShippingState,
  SHIPPING_FORM_ACTION,
  SHIPPING_FORM_STATE,
} from './reducer';

export interface ISHIPPING_FORM_CONTEXT {
  formState: SHIPPING_FORM_STATE;
  dispatch: React.Dispatch<SHIPPING_FORM_ACTION>;
}

export const ShippingFormContext = React.createContext<ISHIPPING_FORM_CONTEXT>({
  formState: initialShippingState,
  dispatch: () => {},
});

export const useShippingFormContext = (): ISHIPPING_FORM_CONTEXT =>
  React.useContext(ShippingFormContext);
